export default {
	computed: {
		$_env_isProduction() {
			return this.$store.getters.getEnv === 'prod'
		},
	}
}

export function $_getApiHost(){
	if (process.env.NODE_ENV === 'development') {
		if(typeof process.env.VUE_APP_APIHOST !== 'undefined'){
			return process.env.VUE_APP_APIHOST;
		}else{
			return 'http://localhost:10280'
		}
	} else {
		return window.location.protocol + '//' + window.location.hostname + (window.location.port !== 80 ? ':' + window.location.port : '')
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/global/env.js